import { observer } from 'mobx-react';
import { useState } from 'react';
import { IStepComponent } from '../../onboarding-page';
import AcceptTermsScreenStore from '../../stores/accept-terms-screen-store';
import { PageLoader } from '../../../../components/page-loader/page-loader';
import useDashboardTranslation from '../../../../dashboard-translation/hooks/dashboard-translation-hook';
import OnBoardingScreenTitle from '../onboarding-screen-title/onboarding-screen-title';
import { Checkbox } from '../../../../components/inputs/checkbox/checkbox';
import OnboardingDefaultNavigationControls from '../onboarding-default-navigation-controls/onboarding-default-navigation-controls';
import OnboardingWizardStickyFooterPortal from '../onboarding-wizard-sticky-footer/onboarding-wizard-sticky-footer-portal';
import './accept-terms-onboarding-screen.scss';

const TRANSLATION_SCOPE = 'dashboard-onboarding';

const AcceptTermsOnboardingScreen: React.FC<IStepComponent> = observer((props) => {
    const store = props.store as AcceptTermsScreenStore;
    const { getTranslation } = useDashboardTranslation();
    const [isChecked, setIsChecked] = useState(store.isComplete());

    if (!store.termsContent || !store.termsVersion) {
        return <PageLoader />;
    }

    const handleAccept = () => {
        if (!isChecked || store.isLoading) {
            return;
        }
        store.acceptTerms();
    };

    return (
        <div className="accept-terms-onboarding-screen">
            <div className="accept-terms-onboarding-screen__body">
                <OnBoardingScreenTitle
                    titleText={getTranslation('ONBOARDING_TERMS_ACCEPTANCE_TITLE', TRANSLATION_SCOPE)}
                />
                <div className="accept-terms-onboarding-screen__terms-box" aria-label="Terms and conditions">
                    <pre className="accept-terms-onboarding-screen__terms-text">{store.termsContent}</pre>
                </div>
                <div className="accept-terms-onboarding-screen__checkbox">
                    <Checkbox
                        label={getTranslation('TERMS_ACCEPTANCE_CHECKBOX_LABEL', TRANSLATION_SCOPE)}
                        checked={isChecked}
                        onChange={setIsChecked}
                        disabled={store.isLoading}
                    />
                </div>
            </div>
            <OnboardingWizardStickyFooterPortal>
                <OnboardingDefaultNavigationControls
                    onBackClick={store.previousStep}
                    onNextClick={handleAccept}
                    isNextDisabled={!isChecked}
                    isBackDisabled={store.isLoading}
                    nextText={getTranslation('TERMS_ACCEPTANCE_ACCEPT_BUTTON', TRANSLATION_SCOPE)}
                    isLoading={store.isLoading}
                />
            </OnboardingWizardStickyFooterPortal>
        </div>
    );
});

export default AcceptTermsOnboardingScreen;
